import { Input } from "@/components/ui/input";
import { ROTA_PALETTE, isHex } from "./rotasHelpers";

// Paleta visual + input nativo de cor + campo hex editável (Iter 98).
export function ColorPicker({ value, onChange }) {
  const cur = (value || "").toUpperCase();
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2" data-testid="rota-color-palette">
        {ROTA_PALETTE.map((c) => {
          const active = cur === c;
          return (
            <button type="button" key={c} onClick={() => onChange(c)} title={c} aria-pressed={active}
              data-testid={`rota-color-${c.slice(1).toLowerCase()}`}
              className={`w-8 h-8 rounded-full border-2 border-white shadow-sm transition-transform hover:scale-110 ${active ? "ring-2 ring-offset-2 ring-slate-800 scale-110" : ""}`}
              style={{ backgroundColor: c }} />
          );
        })}
      </div>
      <div className="flex items-center gap-2">
        <input type="color" value={isHex(value) ? value : "#3B82F6"} onChange={(e) => onChange(e.target.value.toUpperCase())}
          className="w-10 h-9 rounded border cursor-pointer p-0.5 bg-white" title="Cor personalizada" data-testid="rota-color-native" />
        <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="#RRGGBB" maxLength={7}
          className={`w-32 mono uppercase ${isHex(value) ? "" : "border-rose-400 focus-visible:ring-rose-400"}`} data-testid="rota-color-hex" />
        <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
          Prévia
          <span className="w-6 h-6 rounded-full border shadow-inner" style={{ backgroundColor: isHex(value) ? value : "#E2E8F0" }} data-testid="rota-color-preview" />
        </span>
        {!isHex(value) && <span className="text-xs text-rose-600" data-testid="rota-color-error">Use o formato #RRGGBB</span>}
      </div>
    </div>
  );
}
